import FieldText from './FieldText';
import FieldTextStateless from './FieldTextStateless';

export default FieldText;
export { FieldTextStateless };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/field-text/dist/esm/index.js
// module id = 447
// module chunks = 0